<template>
  <div class="upload-container">
    <ul>
      <li v-for="(image,index) in imagesList" :key="'image_'+index">
        <i class="el-icon-error close" @click="delImage(index)"></i>
        <el-image style="width: 100%; height: 100%" lazy fit="cover" :src="image.file_url"
                  :preview-src-list="[image.file_url]"/>
      </li>
      <li class="add-image" @click="openFile" v-if="imagesList.length < maxFiles">
        <span v-if="uploading"><i class="el-icon-loading"></i>上传中</span>
        <span v-else><i class="el-icon-plus"></i>添加图片</span>
      </li>
      <input type="file" style="display: none" name="image" @change="fileUpload()"
             :id="fileId">
    </ul>
  </div>
</template>

<script>

export default {
  name: "upload",
  props: {
    input: {
      type: Array
    },
    value: {
      type: Array
    },
    maxFiles: {
      type: Number,
      default: 6
    }
  },
  data: function () {
    return {
      imagesList: [],
      uploading: false,
      fileId: 0
    }
  },
  methods: {
    openFile: function () {
      if (!this.uploading) {
        document.querySelector("#" + this.fileId).click();
      }
    },
    fileUpload: function () {
      this.uploading = true;
      let fileInput = document.querySelector("#" + this.fileId);
      let formData = new FormData();
      formData.append('image', fileInput.files[0]);
      let _self = this;
      this.$http.upload(formData).then((res) => {
        if (res.status === 'success') {
          _self.imagesList.push(res.data);
        }
        _self.uploading = false;
      });
    },
    delImage: function (index) {
      this.imagesList.splice(index, 1);
    }
  },
  created: function () {
    this.fileId = 'fileId' + parseInt(Math.random() * 100);
    if (!this.value) {
      this.imagesList = [];
    } else {
      this.imagesList = this.value;
    }
  },
  watch: {
    imagesList: function () {
      this.$emit('input', this.imagesList)
    },
    value: function () {
      if (!this.value) {
        this.imagesList = [];
      } else {
        this.imagesList = this.value;
      }
    },
  }
}
</script>

<style scoped lang="less">

.upload-container {
  overflow: hidden;
}

.upload-container li {
  width: 80px;
  height: 80px;
  border: 1px solid #DCDFE6;
  list-style: none;
  float: left;
  margin-right: 20px;
  position: relative;
  margin-bottom: 20px;
}

.close {
  position: absolute;
  top: -5px;
  right: -5px;
  font-size: 20px;
  cursor: pointer;
  color: #b71203;
  z-index: 100;
}

.upload-container .add-image {
  line-height: 80px;
  cursor: pointer;
  text-align: center;
  color: @main-color;
  font-size: @normal-text-font-size;
}
</style>



// WEBPACK FOOTER //
// src/components/i-upload.vue